/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../types.generated";
export type GenerateBulkResumeZipDownloadMutationVariables = Types.Exact<{
  year: Types.Scalars["Float"];
  forceRegenerate?: Types.Maybe<Types.Scalars["Boolean"]>;
}>;

export type GenerateBulkResumeZipDownloadMutation = {
  generateBulkResumeZipDownload: Pick<
    Types.FileDownload,
    "uri" | "name" | "expiry"
  >;
};

export const GenerateBulkResumeZipDownloadDocument = gql`
  mutation GenerateBulkResumeZipDownload(
    $year: Float!
    $forceRegenerate: Boolean
  ) {
    generateBulkResumeZipDownload(
      year: $year
      forceRegenerate: $forceRegenerate
    ) {
      uri
      name
      expiry
    }
  }
`;

/**
 * __useGenerateBulkResumeZipDownloadMutation__
 *
 * To run a mutation, you first call `useGenerateBulkResumeZipDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBulkResumeZipDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBulkResumeZipDownloadMutation, { data, loading, error }] = useGenerateBulkResumeZipDownloadMutation({
 *   variables: {
 *      year: // value for 'year'
 *      forceRegenerate: // value for 'forceRegenerate'
 *   },
 * });
 */
export function useGenerateBulkResumeZipDownloadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    GenerateBulkResumeZipDownloadMutation,
    GenerateBulkResumeZipDownloadMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    GenerateBulkResumeZipDownloadMutation,
    GenerateBulkResumeZipDownloadMutationVariables
  >(GenerateBulkResumeZipDownloadDocument, baseOptions);
}
export type GenerateBulkResumeZipDownloadMutationHookResult = ReturnType<
  typeof useGenerateBulkResumeZipDownloadMutation
>;
export type GenerateBulkResumeZipDownloadMutationResult =
  ApolloReactCommon.MutationResult<GenerateBulkResumeZipDownloadMutation>;
export type GenerateBulkResumeZipDownloadMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    GenerateBulkResumeZipDownloadMutation,
    GenerateBulkResumeZipDownloadMutationVariables
  >;
